import React from 'react';
import { Checkbox } from 'react-aria-components';

const PortalCellCheckbox: React.FC<{ isChecked: boolean; rowNumber: number; onChange: () => void }> = ({
  isChecked,
  rowNumber,
  onChange,
}) => {
  const allRowsCheck = rowNumber === 0 ? 'Select all rows' : `Select row ${rowNumber}`;

  return (
    <div className="portal-cell portal-cell--checkbox">
      <Checkbox className="portal-cell__checkbox" isSelected={isChecked} aria-label={allRowsCheck} onChange={onChange}>
        <svg className="portal-cell__checkbox-icon" aria-hidden="true">
          <use href="/dist/assets/icons/sprite.svg#check"></use>
        </svg>
      </Checkbox>
    </div>
  );
};

export default PortalCellCheckbox;
